<template>
    <Navigation />
    <NFLTotals />
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import NFLTotals from '../components/NFLTotals.vue';


export default {
  name: 'Home',
  components: {
    Navigation,
    NFLTotals
}
}
</script>